import {asyncType} from '../helpers';

export const settingsReducerKey = 'settings';

export default {
   GET_BACKUP_SETTINGS: asyncType(`${settingsReducerKey}/GET_BACKUP_SETTINGS`),
   GET_FTP_SETTINGS: asyncType(`${settingsReducerKey}/GET_FTP_SETTINGS`),
   GET_KEY_SETTINGS: asyncType(`${settingsReducerKey}/GET_KEYS_SETTINGS`),
   GET_JOB_HISTORY_SETTINGS: asyncType(`${settingsReducerKey}/GET_JOB_HISTORY_SETTINGS`),
   GET_AUDIT_TRAIL_SETTINGS: asyncType(`${settingsReducerKey}/GET_AUDIT_TRAIL_SETTINGS`),
   GET_EMAIL_SETTINGS: asyncType(`${settingsReducerKey}/GET_EMAIL_SETTINGS`),
   GET_PAGING_SETTINGS: asyncType(`${settingsReducerKey}/GET_PAGING_SETTINGS`),

   SAVE_AUDIT_TRAIL_SETTINGS: asyncType(`${settingsReducerKey}/SAVE_AUDIT_TRAIL_SETTINGS`),
   POST_AUDIT_TRAIL_SETTINGS: asyncType(`${settingsReducerKey}/SAVE_AUDIT_TRAIL_SETTINGS`),

   GET_JOB_SETTINGS: asyncType(`${settingsReducerKey}/GET_JOB_SETTINGS`),
   POST_JOB_SETTINGS: asyncType(`${settingsReducerKey}/POST_JOB_SETTINGS`),

   GET_ARCHIVE_SETTINGS: asyncType(`${settingsReducerKey}/GET_ARCHIVE_SETTINGS`),
   POST_ARCHIVE_SETTINGS: asyncType(`${settingsReducerKey}/POST_ARCHIVE_SETTINGS`),

   GET_SUPPORT_EMAIL_SETTINGS: asyncType(`${settingsReducerKey}/GET_SUPPORT_EMAIL_SETTINGS`),
   POST_SUPPORT_EMAIL_SETTINGS: asyncType(`${settingsReducerKey}/POST_SUPPORT_EMAIL_SETTINGS`),

   GET_LOGGING_SETTINGS: asyncType(`${settingsReducerKey}/GET_LOGGING_SETTINGS`),
   POST_LOGGING_SETTINGS: asyncType(`${settingsReducerKey}/POST_LOGGING_SETTINGS`),

   GET_SESSION_SETTINGS: asyncType(`${settingsReducerKey}/GET_SESSION_SETTINGS`),
   POST_SESSION_SETTINGS: asyncType(`${settingsReducerKey}/POST_SESSION_SETTINGS`),

   GET_AUDIT_ARCHIVE_STATUS: asyncType(`${settingsReducerKey}/GET_AUDIT_ARCHIVE_STATUS`),
   CANCEL_ARCHIVING: asyncType(`${settingsReducerKey}/CANCEL_ARCHIVING`),

   CREATE_ADMIN_ROLE: asyncType(`${settingsReducerKey}/CREATE_ADMIN_ROLE`),
   DELETE_ADMIN_ROLE: asyncType(`${settingsReducerKey}/DELETE_ADMIN_ROLE`),
   FETCH_ADMIN_ROLES: asyncType(`${settingsReducerKey}/FETCH_ADMIN_ROLES`),
   FETCH_ADMIN_ROLE_BY_ID: asyncType(`${settingsReducerKey}/FETCH_ADMIN_ROLE_BY_ID`), //@not used
   UPDATE_ADMIN_ROLES: asyncType(`${settingsReducerKey}/UPDATE_ADMIN_ROLES`),
};
